import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BookingFullDTO, ContentCullDTO} from '../../../services/api/api';
import {ModalService} from '../../../services/gui/modal/modal.service';
import {UtilService} from '../../../services/util.service';
import {NetworkBookingsListComponent} from '../../../pages/network/network-bookings-list/network-bookings-list.component';

@Component({
  selector: 'sb-comp-filter-content-cull',
  templateUrl: './sb-filter-content-cull.component.html',
  styleUrls: ['./sb-filter-content-cull.component.scss'],
  standalone: false,
})
export class SbFilterContentCullComponent implements OnInit {
  @Input() cull: ContentCullDTO;
  @Input() easyMode: boolean;
  @Input() disabled: boolean;

  @Output() cullChange: EventEmitter<ContentCullDTO> = new EventEmitter<ContentCullDTO>();

  loading: boolean;

  bookings: BookingFullDTO[];

  inverted: boolean;

  constructor(
    public modal: ModalService,
    public util: UtilService
  ) {
    this.loading = true;
    this.disabled = false;
    this.inverted = false;
    this.bookings = [];
  }

  ngOnInit(): void {
    if (this.cull && this.cull?.staticElements) {
      this.bookings = this.cull.staticElements;
      this.inverted = this.cull.invertedStatic;
    } else {
      this.bookings = [];
      this.inverted = false;
    }

    this.loading = false;
  }

  addBookingRow() {
    const initialBookings = JSON.parse(JSON.stringify(this.bookings));
    this.modal
      .showNavigationModal({
        entryComponent: { value: NetworkBookingsListComponent, data: { bookings: initialBookings } },
        title: null,
        modalOptions: {
          // windowClass: 'bigXL',
          size: 'xl',
        },
      })
      .then((result: BookingFullDTO[]) => {
        if (result && result.length >= 0) {
          this.addBooking(result);
        }
      })
      .catch(() => {});
  }

  addBooking(bookings: BookingFullDTO[]) {
    this.bookings = bookings;
    this.updateDTO();
  }

  removeBooking(index: number) {
    this.bookings.splice(index, 1);
    this.updateDTO();
  }

  emitChange(cull?: ContentCullDTO) {
    this.cullChange.emit(cull ? cull : this.cull);
  }

  toggleInverted() {
    this.inverted = !this.inverted;
    this.updateDTO();
  }

  updateDTO() {
    this.cull.staticElements = this.bookings;
    this.cull.invertedStatic = this.inverted;

    this.emitChange();
  }
}
